<template>
  <div class="card-container">
    <common-top-form
      selectShowPower="/merchantgrowthfunddetails/select"
      :model="formModel"
      :submitService="submitService"
      :submitData="submitData"
      @success="onSuccess"
      :show="false"
    >
      <el-form-item label="商户号">
        <el-input
          v-model="formModel.merchantNo"
          placeholder="请输入"
        ></el-input>
      </el-form-item>
      <el-form-item label="商户手机号">
        <el-input v-model="formModel.phone" placeholder="请输入"></el-input>
      </el-form-item>
      <el-form-item label="策略名称">
        <el-select v-model="formModel.strategyId">
          <el-option
            v-for="item in strategyId"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="状态">
        <el-select v-model="formModel.status">
          <el-option
            v-for="item in status"
            :key="item.dictKey"
            :label="item.dictValue"
            :value="item.dictKey"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <!-- <el-form-item label="创建时间">
        <el-date-picker
          v-model="formModel.time"
          type="daterange"
          range-separator="至"
          :clearable="true"
          value-format="yyyy-MM-dd"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
        >
        </el-date-picker>
      </el-form-item> -->
    </common-top-form>
    <common-table :data="tableData" ref="commonTable" @handleChange="getPage">
      <el-table-column
        prop="merchantNo"
        label="商户号"
        :formatter="formatterTableData"
        min-width="160"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="merName"
        label="商户名称"
        :formatter="formatterTableData"
        min-width="160"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="phone"
        label="商户手机号"
        :formatter="formatterTableData"
        min-width="160"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="strategyName"
        label="策略名称"
        min-width="260"
        show-overflow-tooltip
        :formatter="formatterTableData"
      ></el-table-column>
      <el-table-column
        prop="tranAmt"
        label="成长金额度"
        :formatter="formatterTableNumber"
        min-width="160"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="realTranAmt"
        label="已使用额度"
        :formatter="formatterTableNumber"
        min-width="160"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="returnRate"
        label="返现比例(%)"
        min-width="120"
        show-overflow-tooltip
        :formatter="formatterTableNumberYuan"
      ></el-table-column>
      <el-table-column
        fixed="right"
        prop="createTime"
        label="开始时间"
        min-width="160"
        show-overflow-tooltip
        :formatter="formatterTableData"
      ></el-table-column>
      <el-table-column
        fixed="right"
        prop="endTime"
        label="到期时间"
        min-width="160"
        show-overflow-tooltip
        :formatter="formatterTableData"
      ></el-table-column>
      <el-table-column
        prop="status"
        label="状态"
        min-width="120"
        show-overflow-tooltip
        :formatter="formatterTabstatus"
      ></el-table-column>
    </common-table>
  </div>
</template>

<script>
import CommonTopForm from "components/common/CommonTopForm";
import CommonTable from "components/common/CommonTable";
import TransactionService from "service/TransactionService";
import { encrypt, urlEncode, objKeySort } from "common/js/common-utils";
import { loadMixin, dialogMixin, validatorsMixin } from "mixin";
import { mapGetters } from "vuex";

export default {
  name: "merchantgrowthfunddetails",
  components: {
    CommonTopForm,
    CommonTable,
  },
  data() {
    return {
      formModel: {
        merchantNo: "",
        phone: "",
        // time: "",
        strategyId: "",
        status: "",
      },
      strategyId: [{ id: "", name: "全部" }],
      status: [
        {
          dictKey: "",
          dictValue: "全部",
        },
        {
          dictKey: "0",
          dictValue: "未完成",
        },
        {
          dictKey: "1",
          dictValue: "已完成",
        },
        {
          dictKey: "3",
          dictValue: "已过期",
        },
      ],
      tableData: [],
      submitService: TransactionService.merchantgrowthfunddetailsList,
      params: {},
      page: {},
      isPage: false,
    };
  },
  inject: ["reload"],
  mixins: [loadMixin, dialogMixin, validatorsMixin],
  mounted() {
    this.load();
  },
  computed: {
    submitData() {
      // if (this.formModel.time == null || this.formModel.time == "") {
      //   this.formModel.time = [];
      // }
      const params = {
        merchantNo: this.formModel.merchantNo,
        phone: this.formModel.phone,
        strategyId: this.formModel.strategyId,
        status: this.formModel.status,
        current: this.isPage ? this.page.currentPage : 1,
        size: this.page.pageSize,
      };
      // if (this.formModel.time.length) {
      //   params.startDate = this.formModel.time[0];
      //   params.endDate = this.formModel.time[1];
      // }
      return params;
    },
    ...mapGetters(["serverType", "tatId", "userId", "userInfo"]),
  },
  methods: {
    load() {
      this.formModel = {
        // time: "",
        strategyId: "",
        status: "",
      };
      this.page = this.$refs.commonTable.page;
      this.getList();
      this.getstrategyId();
    },
    getPage() {
      this.isPage = true;
      this.getList();
    },
    getList() {
      this.doLoad(
        this.submitService,
        this.submitData,
        (res) => {
          this.doCheck(res, (res) => {
            this.onSuccess(res);
            this.isPage = false;
          });
        },
        "信息获取失败"
      );
    },
    getstrategyId() {
      this.doLoad(
        TransactionService.apppointstransactionmanageList,
        {
          size: 9999,
        },
        (res) => {
          this.doCheck(res, (res) => {
            console.log(res);
            this.strategyId = [...this.strategyId, ...res.contents.rows];
          });
        },
        "信息获取失败"
      );
    },
    onSuccess(res) {
      this.doCheck(res, (res) => {
        const result = res.contents;
        this.tableData = result.rows;
        this.page.currentPage = result.current;
        this.page.total = result.total;
        this.page.pageSize = result.size;
      });
    },
    formatterTablestrategyId(row, column, cellValue, index) {
      let value = "--";
      this.strategyId.forEach((item) => {
        if (item.id == cellValue) {
          value = item.name;
        }
      });
      return value;
    },
    formatterTabstatus(row, column, cellValue, index) {
      let value = "--";
      this.status.forEach((item) => {
        if (item.dictKey == cellValue) {
          value = item.dictValue;
        }
      });
      return value;
    },
  },
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/view/page/AppManager/MerchantGrowthFundDetails.vue